import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts `YYYY-MM-DD` strings to a Date using local time (not UTC).
 * Angular's built-in `date` pipe parses date-only strings as UTC, which can shift by -1 day.
 */
@Pipe({
  name: 'dateOnlySafe',
  standalone: true,
})
export class DateOnlySafePipe implements PipeTransform {
  transform(value: unknown): Date | null {
    if (value === null || value === undefined || value === '') return null;

    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }

    if (typeof value === 'string') {
      const s = value.trim();

      // Treat date-only strings as local dates.
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
      if (m) {
        const year = Number(m[1]);
        const month = Number(m[2]); // 1-12
        const day = Number(m[3]);
        if (Number.isFinite(year) && Number.isFinite(month) && Number.isFinite(day)) {
          const dt = new Date(year, month - 1, day);
          return isNaN(dt.getTime()) ? null : dt;
        }
      }

      const dt = new Date(s);
      return isNaN(dt.getTime()) ? null : dt;
    }

    if (typeof value === 'number') {
      const dt = new Date(value);
      return isNaN(dt.getTime()) ? null : dt;
    }

    return null;
  }
}

